import { Button } from "@progress/kendo-react-buttons";
import { DateInputProps, DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { StackLayout } from "@progress/kendo-react-layout";
import { formatDate, getDateWithoutTime } from "../commons/helpers/Dates";
import { Agence } from "../models/Agence";
import { Magasin } from "../models/Magasin";
import { useGetMagasinsQuery } from "../redux/api/cache";
import { useMemo } from "react";

interface HeaderProps {
    date: Date
    setDate: React.Dispatch<React.SetStateAction<Date>>;
    magasin: Magasin;
    setMagasin: React.Dispatch<React.SetStateAction<Magasin>>;
    itemInEdit: boolean;
    agences: Agence[];
    agence: Agence;
    setAgence: React.Dispatch<React.SetStateAction<Agence>>;
}

export default function Header(props: HeaderProps) {
    const today = getDateWithoutTime(new Date());
    const minDate = useMemo(() => new Date(today.getFullYear(), today.getMonth() - 2, 1), []);
    const maxDate = useMemo(() => {
        let maxDay = new Date(today.getTime());
        maxDay.setDate(maxDay.getDate() + 14 + (6 - maxDay.getDay()))
        return maxDay;
    }, [])

    const { data: magasins = [] } = useGetMagasinsQuery(props.agence.agence_cd, { skip: !props.agence.agence_cd });

    const getPreviousDate = (): Date => {
        let tempDate = new Date(props.date.getTime());
        tempDate.setDate(tempDate.getDate() - 1);

        return tempDate;
    }

    const getNextDate = (): Date => {
        let tempDate = new Date(props.date.getTime());
        tempDate.setDate(tempDate.getDate() + 1);

        return tempDate;
    }

    const customDateInput = (props: DateInputProps) => {
        return <input className="k-input-inner k-h-full" role="combobox" type="text" tabIndex={0} spellCheck={false} autoComplete="off"
            autoCorrect="off" aria-haspopup="grid" aria-disabled={false} aria-expanded={false} defaultValue={formatDate(props.value!)} readOnly />;
    };

    return <StackLayout gap={5} align={{ horizontal: "start" }} >
        {props.agences.length >= 2 &&
            (<div className="k-d-flex k-gap-2 k-align-items-center k-w-full" style={{ minWidth: "180px", maxWidth: "450px" }}>
                <Label>Agence</Label>
                <DropDownList data={props.agences.map(a => a.agence_nom)} onChange={(e) => { props.setAgence(props.agences.find(a => a.agence_nom === e.value)!) }} value={props.agence.agence_nom} disabled={props.itemInEdit}
                    className="k-h-full"
                />
            </div>)
        }
        <div className="k-d-flex k-gap-2 k-align-items-center k-w-full" style={{ minWidth: "250px", maxWidth: "450px" }}>
            <Label>Magasin/Entrepôt</Label>
            <DropDownList data={magasins.map(m => m.mag_nom_aff)} onChange={(e) => { props.setMagasin(magasins.find(m => m.mag_nom_aff === e.value)!) }} value={props.magasin.mag_nom_aff} disabled={props.itemInEdit}
                className="k-h-full"
            />
        </div>
        <div className="k-d-flex k-gap-2 k-align-items-center">
            <Button onClick={() => props.setDate(getPreviousDate())} disabled={props.itemInEdit || (getPreviousDate().getTime() < minDate.getTime())}><span className="k-h-full k-align-middle">{formatDate(getPreviousDate())}</span> <span className="k-icon k-font-icon k-i-arrow-left k-icon-xl"
            /></Button>
            <DatePicker placeholder="Choisir une date" className="toolbar-input k-h-full" onChange={(e) => props.setDate(getDateWithoutTime(e.value as Date))} value={props.date} format={"EEEE yyyy-MM-dd"} dateInput={customDateInput} disabled={props.itemInEdit}
                width={210} min={minDate} max={maxDate}
            />
            <Button onClick={() => props.setDate(getNextDate())} disabled={props.itemInEdit || (getNextDate().getTime() > maxDate.getTime())}><span className="k-icon k-font-icon k-i-arrow-right k-icon-xl" /> <span className="k-h-full k-align-middle">{formatDate(getNextDate())}</span></Button>
        </div>
    </StackLayout>;
}